import React, { FC } from "react";
import { get } from "lodash";
import styled from "styled-components";

import { evaluateExpression } from "./evaluateExpression";
import { JsonSchemaArrayOfObjects } from "./JsonSchemaArrayOfObjects";
import { JsonSchemaFields } from "./JsonSchemaFields";
import { Label } from "./Label";
import { ListButton } from "./ListButton";
import {
    IInputProps,
    IPropertyObject,
    JsonSchema,
    ServiceParameters,
} from "./types";

export interface IJsonSchemaObjectProps extends IInputProps {
    properties: IPropertyObject;
}

export const JsonSchemaObject: FC<IJsonSchemaObjectProps> = props => {
    const {
        params,
        setParams,
        currentPath,
        setCurrentPath,
        properties,
        validation,
    } = props;

    const content = Object.keys(properties)
        .filter(key => key !== "required")
        .map(key => {
            const childSchema = properties[key];
            if (!childSchema.title) {
                childSchema.title = key;
            }

            const nextPath = [...currentPath, key];
            if (
                !evaluateExpression(
                    params,
                    nextPath,
                    childSchema["$formant.visible.when"],
                )
            ) {
                return null;
            }

            if (childSchema.type === "object") {
                if (
                    !evaluateExpression(
                        params,
                        nextPath,
                        childSchema["$formant.visible.when"],
                    )
                ) {
                    return (
                        <React.Fragment
                            key={[nextPath, "empty", "basic-object", key].join(
                                ".",
                            )}
                        />
                    );
                }
                return (
                    <React.Fragment
                        key={[nextPath, "empty", "basic-object", key].join(".")}
                    >
                        <Label
                            value={childSchema.title}
                            description={childSchema.description}
                        />
                        <ListButton
                            onClick={() => {
                                setCurrentPath([...nextPath]);
                            }}
                            empty={
                                (get(params, nextPath) || undefined) !==
                                undefined
                            }
                            icon="chevron-right"
                        >
                            Edit
                        </ListButton>
                    </React.Fragment>
                );
            }

            if (isArrayOfObjects(childSchema)) {
                return (
                    <JsonSchemaArrayOfObjects
                        key={[
                            nextPath,
                            "arayOfObjects",
                            "basic-object",
                            key,
                        ].join(".")}
                        path={nextPath}
                        params={params}
                        setParams={setParams}
                        currentPath={currentPath}
                        setCurrentPath={setCurrentPath}
                        schema={childSchema}
                        validation={validation}
                    />
                );
            }

            return (
                <JsonSchemaFields
                    key={[
                        nextPath,
                        childSchema.title,
                        "recursiveField",
                        key,
                    ].join(".")}
                    schema={childSchema}
                    path={nextPath}
                    params={params}
                    setParams={setParams}
                    currentPath={currentPath}
                    setCurrentPath={setCurrentPath}
                    validation={validation}
                />
            );
        });

    return <Container>{content}</Container>;
};

const isArrayOfObjects = (schema: JsonSchema) => {
    if (schema.type === "array") {
        const { items } = schema;
        if (items.type === "object") {
            return true;
        }
    }
    return false;
};

export const getArrayValue = (
    params: ServiceParameters,
    currentPath: string[],
): [] => {
    return get(params, currentPath) || [];
};

const Container = styled.div`
    margin-left: 1.5rem;
    margin-right: 1.5rem;
`;
